<div
  class="flow-loader"
  [ngClass]="[color, size]"
  [ngStyle]="getStyles()"
  role="status"
  aria-label="Loading">
</div>
